import styled from 'styled-components'
import { FONT } from 'theme/font'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import { Divider } from 'antd'

export const RoleColHead = styled.h1`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 1.4em;
  color: ${COLORS.GREY_T_20};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const RoleColComment = styled.p`
  margin-bottom: 0;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  text-transform: capitalize;
`
export const CompressedText = styled(Flex)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
`
export const RowNumberData = styled(Flex)`
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`

export const RowNumberData1 = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: #3249d7;
  text-transform: capitalize;
  padding-top: 5px;
  cursor: pointer;
`
export const RowNumberDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: #3249d7;
  text-transform: capitalize;
  cursor: pointer;
`
export const LightText = styled.div`
  font-weight: ${FONT.FW_400};
  font-size: 15px;
  line-height: 20px;
  color: #d8d8d8;
`
export const UpTag = styled(Flex)`
  padding: 5px 10px;
  margin-left: 10px;
  gap: 5px;
  border-radius: 20px;
  border: 1px solid ${COLORS.GREY_T_90};
  background-color: ${COLORS.PRIMARY_GREY_T_98};
`
export const DivWrapper = styled.div`
  max-width: ${props => (props?.maxwidth ? props?.maxwidth : '100%')};
`
export const Wrapper = styled.div`
  padding-bottom: 100px;
`
export const FlexWrap = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const JustifyContent = styled(Flex)`
  justify-content: center;
`
export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`
export const RowNumberDataReport = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`
export const FilterWrapper = styled.div`
  padding: 1rem 0.5rem;
`
export const SkillRow = styled(Flex)`
  gap: px;
`
export const ReportWrapper = styled.div``

export const RowNumberDataReportAlignCenter = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  align-items: center;
  justify-content: center;
  display: flex;
`
export const RowNumberDataReportAlignCenterDegreeFilter = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  align-items: center;
  justify-content: center !important;
  display: flex;
  display: flex;
  margin-top: 5rem;
`
export const RowNumberDataReportCapitalize = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: uppercase;
`
export const RowNumberDriveAlignCenter = styled(Flex)`
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
  align-items: center;
  justify-content: center;
  display: flex;
`
export const RowNumberDriveAlignCenterItem = styled.div`
  justify-content: center;
  display: flex;
`

export const TreeMargin = styled.div`
  margin-top: 1em;
`
export const InfoSection = styled(Flex)`
  gap: 1px;
  margin-left: 10px;
  flex-direction: column;
`

export const InfoText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #343e59;
`

export const GreenStarSpan = styled.span`
  margin: 0 0 0 5px;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  display: flex;
  align-items: baseline;
  justify-content: center;
`

export const SelectStatusFlex = styled.div`
  display: flex;
  gap: 1em;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
`

export const AllowButton = styled.div`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 250px !important;

    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-tabs-tab {
    padding: 15px !important;
  }
  .ant-tabs-tabpane.ant-tabs-tabpane-active {
    height: 100%;
  }

  .ant-tabs-tab-btn {
    white-space: break-spaces;
  }
`
export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const SpanDescription = styled.div`
  font-weight: 600;
  position: relative;
  top: -1rem;
  font-size: 1rem;
`
export const StyledDivider = styled(Divider)`
  margin: 0 10px;
  border-color: rgba(223, 223, 223, 1);
  height: 40px;
  align-self: center;
`

export const OptOutText = styled.div`
font-family: Plus Jakarta Sans;
font-weight: 400;
font-size: 12px;
line-height: 18px;
color: #FF0000;
`